// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__nYkVy","name":"Header_name__3fj4E","birthday":"Header_birthday__x7b8V","skeleton":"Header_skeleton__1k5pR"};